import { NavLink } from 'react-router-dom'
import Wordmark from './Wordmark'
import ThemeToggle from './ThemeToggle'

const linkClass = ({ isActive }: { isActive: boolean }) =>
  [
    'rounded px-3 py-2 text-sm font-semibold',
    isActive ? 'text-accent-text' : 'text-ink-muted',
  ].join(' ')

export default function SiteHeader() {
  return (
    <header className="border-b border-line bg-canvas">
      {/*
        Wraps rather than holding one row. The brand, the link, and the theme
        control do not fit 320px together, and WCAG 1.4.10 requires the page
        to work at that width without sideways scrolling. Wrapping keeps
        every control reachable without introducing a menu pattern to open.

        No separate Home link and no Sign in button: the wordmark already
        goes to "/", and "/" is the sign-in screen, so either would just be
        a second link to the page already showing.
      */}
      <div className="page-shell flex flex-wrap items-center justify-between gap-x-4 gap-y-2 py-3 sm:py-4">
        {/* The product's own name. The MetaPhase mark belongs in the footer
            credit, not in front of a product built for somebody else. */}
        <NavLink to="/" className="flex min-w-0 items-center gap-2.5 text-lg font-bold tracking-tight">
          <Wordmark className="h-7 w-auto max-w-full" />
        </NavLink>

        <div className="flex shrink-0 items-center gap-1">
          <nav aria-label="Main">
            <ul className="flex items-center gap-1">
              <li>
                <NavLink to="/about" className={linkClass}>
                  About
                </NavLink>
              </li>
            </ul>
          </nav>
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}
